import { StackProps } from "@tamagui/core";

export type StyleObject =
  | StackProps["style"]
  | [boolean | undefined | null, StackProps["style"]]
  | false
  | null
  | undefined;

export function stylex(...styles: StyleObject[]) {
  return Object.assign(
    {},
    ...styles.flatMap((style) => {
      if (Array.isArray(style)) {
        return style[0] ? style[1] : [];
      }
      return style ? [style] : [];
    }),
  );
}
